<template>
<div class="mt-3">

<spinner v-bind:spinner='spinner'></spinner>

<!--      
<div class="card border-success">
  <div class="card-header bg-success text-white">
        <h4> <i class="fas fa-sync-alt mr-2" aria-hidden="true"></i>  SOSTITUZIONE COLORE</h4>
    </div>
    <div class="card-body text-dark">
-->      
    <div class="col-4">
    <div class="form-group">
        <label for="color"><strong>Colori prodotto</strong></label>  
        <select id='color'  class="form-control" v-model="productColorId">
            
            <option v-for="(item,index) in items" :key="index" :value="item.colorId" >
                {{item.color}}
            </option>                    
        </select>  
    </div>
    <div class="form-group">
        <label for="colorList"><strong>Colori disponibili</strong></label>  
        <select id='colorList'  class="form-control" v-model="colorId">
            
            <option v-for="(item,index) in colors" :key="index" :value="item.colorId" >
                {{item.color}}
            </option>                    
        </select>  
    </div>
    

    <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <button :disabled="items.length==0" @click="submit()"  class="btn btn-primary float-right mt-2">
    <i class="fas fa-save mr-2" aria-hidden="true"></i>
    MODIFICA
    <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
    
    </div>

    <!--
    </div>
    </div>
    -->


</div>



</template>

<script>

import { mapGetters }     from 'vuex';
import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';
import spinner            from '@/components/common/Spinner.vue';


export default {
   props : ['item'],
   components: {alertBox,spinner},  
  

  data () {
    return {      

      items           : [], 
      colors          : [],
      colorId         : 0,
      productColorId  : 0,   
      msg             : {
        title : ''
      },
      alert           : false,
      spinner         : false,
      

    }
  },
  computed: 
  {  
      ...mapGetters(['company']),
  },
   directives: 
    {

      focus: {
      
      inserted: function (el) 
      {
       
        //el.focus() 
      
      }
      
      }

    },
  mounted()
    {
        this.getData()
    },
  created()
  {
       
  },
  methods: 
  {
    async getData()
    {
    
    this.spinner  = true
        
    var data      = {'productId' : this.item.productId,'companyId':this.company.Id}
    var sp        = {'sp' : 'spProductColorSwapping'}
    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
               
              this.items = res.data.recordsets[0]
              this.colors = res.data.recordsets[1]

              this.$nextTick().then(function () {
              
                
               })

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    
    },
    async submit()
    {

      if(this._colorId == 0 || this.colorId == 0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'SELEZIONE COLORI NON VALIDA.'
        this.msg.type  = 1 
        return
      }  
      var data                = {'productId':this.item.productId,'color1':this.productColorId,'color2':this.colorId}      
      this.spinner  = true      
      var sp        = {'sp' : 'spUpdateProductColorSwapping'}
      var json      = Object.assign(data, sp)

      await api.post(json).then(res => {
          
          

          if(res.status==200)
            {
                
                this.msg.title = "MODIFICA EFFETTUATA."
                this.msg.body = ''
                this.msg.type  = 0
                this.getData()
            }
           else if(res.status==500)
           {
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                            
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res
                this.msg.type  = 1
                 
            } 

        

          }).catch(err => {
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1   

              
          }).finally(() => {
          this.spinner = false
        });





    }
  
  
  }
  
   
  
}

</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
    .bold
    {
        font-weight  : bold;
    }
    
    label{
      color  :  blue
    }
    p {
      font-family  : 'Roboto Condensed';
      font-size    : 25px;
    }
    span {
      font-family  : 'Roboto Condensed';
      font-size    : 15px;
    }
</style>